const Entrance = () => {
  return (
    <>
      <p className='fw-bold'>ENTRANCE EXAM :</p>
      <ul className="lh-lg">
        <li>After Passing Entrance Exam, Only You Can continue the Admission in Shanthi Rani.</li>
        <li>1 Standard to 9th Standard students have Entrance Exam.</li>
        <li>For 11th Standard, Admission is based on 10th standard marks.</li>
      </ul>
    </>
  )
}

export default Entrance
